import React from 'react'
import axios from 'axios'

function VideoUploader(props) {
  const resetFile = () => {
    // Reset file input control
    document.getElementsByName(props.name)[0].value = null
  }

  const onSubmit = () => {
    if (document.getElementById('home-video-fondo-file').files.length !== 0) {
      props.setSpinnerIsActive(true)

      const data = new FormData()

      for (let i = 0; i < document.getElementById('home-video-fondo-file').files.length; i++) {
        data.append('file[]', document.getElementById('home-video-fondo-file').files[i])
      }

      data.append('name', props.name)

      let url = 'https://puntosurgdl.com/backend/'

      axios
        .post(url + 'videoUpload.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            console.log(res.data.data[0])
            // then print response status
            //this.setState({responseArray: res.data.data[0]})
            console.log(res.data.data[0].url)
            document
              .getElementById('home-video-fondo-source')
              .setAttribute('src', res.data.data[0].url)
            document.getElementById('home-video-fondo').load()
            props.setSpinnerIsActive(false)
            resetFile()
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      alert('Por favor seleccione un archivo')
      return false
    }
  }

  return (
    <div className='row'>
      <div className='form-group col-md-10'>
        <label>Cambiar video:</label>
        <input
          id='home-video-fondo-file'
          type='file'
          className='form-control'
          name={props.name}
          accept='.mp4'
        />
      </div>
      <div className='form-group col-md-2'>
        <button type='submit' className='btn btn-primary mt-6' onClick={() => onSubmit()}>
          Cambiar video
        </button>
      </div>
      <div id='videoHelp' class='form-text'>
        Subir un archivo .mp4 de no más de 40MB de peso.
      </div>
    </div>
  )
  // return (
  //   <div className="row">
  //     <div className="col-md-12">

  //       <div className="form-row">
  //         <div className="form-group col-md-6">
  //           <label>Nuevo video:</label>
  //           <input
  //             type="file"
  //             className="form-control"
  //             multiple
  //             name="file"
  //             onChange={this.handleInputChange}
  //           />
  //         </div>
  //       </div>
  //       <br />
  //       <div className="form-row">
  //         <div className="col-md-6">
  //           <button
  //             type="submit"
  //             className="btn btn-primary"
  //             onClick={() => this.onSubmit()}
  //           >
  //             Subir video
  //           </button>
  //         </div>
  //       </div>
  //       <br />
  //       {this.state.responseArray.map((res, i) => (
  //         <div key={i}>
  //             <div  className={'img-alert alert alert-'+res.status}>
  //               <div>{res.message} : {res.url}</div>
  //               <img src={res.base64} />
  //             </div>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );
}

export {VideoUploader}

// class VideoUploader extends React.Component {
//   constructor() {
//     super()
//     this.state = {
//       selectedFile: '',
//       responseArray: [],
//     }
//     this.handleInputChange = this.handleInputChange.bind(this)
//     this.setSpinnerIsActive = this.setSpinnerIsActive.bind(this)
//   }

//   handleInputChange(event) {
//     this.setState({
//       selectedFile: event.target.files,
//       responseArray: [],
//     })
//   }

//   onSubmit() {
//     if (!this.state.selectedFile) {
//       alert('Please select a file!')
//       return false
//     }

//     this.setSpinnerIsActive(true)
//     const data = new FormData()

//     for (let i = 0; i < this.state.selectedFile.length; i++) {
//       data.append('file[]', this.state.selectedFile[i])
//     }

//     data.append('name', this.props.name)

//     let url = 'https://puntosurgdl.com/backend/'

//     console.log(data)
//     console.log(url)

//     axios
//       .post(url + 'videoUpload.php', data, {
//         // receive two parameter endpoint url ,form data
//       })
//       .then(
//         (res) => {
//           console.log(res.data.data[0])
//           // then print response status
//           this.setState({responseArray: res.data.data[0]})
//           console.log(res.data.data[0].url)
//           document
//             .getElementById('home-video-fondo-source')
//             .setAttribute('src', res.data.data[0].url)
//           document.getElementById('home-video-fondo').load()
//           this.resetFile()
//         },
//         (error) => {
//           alert(error)
//         }
//       )
//   }

//   resetFile() {
//     // Reset file input control
//     document.getElementsByName(this.props.name)[0].value = null
//   }

//   render() {
//     return (
//       <div className='row'>
//         <div className='form-group col-md-10'>
//           <label>Cambiar video:</label>
//           <input
//             type='file'
//             className='form-control'
//             name={this.props.name}
//             onChange={this.handleInputChange}
//           />
//         </div>
//         <div className='form-group col-md-2'>
//           <button type='submit' className='btn btn-primary mt-6' onClick={() => this.onSubmit()}>
//             Cambiar video
//           </button>
//         </div>
//       </div>
//     )
//     // return (
//     //   <div className="row">
//     //     <div className="col-md-12">

//     //       <div className="form-row">
//     //         <div className="form-group col-md-6">
//     //           <label>Nuevo video:</label>
//     //           <input
//     //             type="file"
//     //             className="form-control"
//     //             multiple
//     //             name="file"
//     //             onChange={this.handleInputChange}
//     //           />
//     //         </div>
//     //       </div>
//     //       <br />
//     //       <div className="form-row">
//     //         <div className="col-md-6">
//     //           <button
//     //             type="submit"
//     //             className="btn btn-primary"
//     //             onClick={() => this.onSubmit()}
//     //           >
//     //             Subir video
//     //           </button>
//     //         </div>
//     //       </div>
//     //       <br />
//     //       {this.state.responseArray.map((res, i) => (
//     //         <div key={i}>
//     //             <div  className={'img-alert alert alert-'+res.status}>
//     //               <div>{res.message} : {res.url}</div>
//     //               <img src={res.base64} />
//     //             </div>
//     //         </div>
//     //       ))}
//     //     </div>
//     //   </div>
//     // );
//   }
// }

export default VideoUploader
